export const css = {
	root: '_2bIzruqd',
	toolbar: '_2dYpL0sH',
	alphabutton: '_2FzLW15m',
	numberbutton: 'xZVqygrV',
	searchinput: 'XTlayZJY',
	selectedbutton: 'MPHjsbom',
	invalidbutton: '_6tWdIiXC',
	result: '_2mRk-iF7',
	terms: '_2yGTOoPA',
	term: 'JBzijVoy',
	definition: '_2BZRcnFb',
	' _key': 'certwise-theme/certwise/glossary/glossary'
};

export default css;
